import React from 'react';
import styled from 'styled-components';

import Principle from '../components/principle';
import Section from '../components/section';
import { Overview, Title } from '../components/text';
import { stylesFor } from '../styles/utilities';

const List = styled.ul`
  list-style-type: none;
  margin: 0;
  padding: 0;

  ${stylesFor.xLargeUp`
    column-count: 2;
  `};
`;

export default () => {
  return (
    <Section background="#f9f9f9">
      <Title>SharePoint design principles</Title>
      <Overview>
        SharePoint builds on the design principles that shape the Office and
        Microsoft product families. These principles help the design stay true
        to our product goals and user needs.
      </Overview>

      <List>
        <Principle
          icon="images/iconSpeed.svg"
          name="Optimistic and fast"
          description="SharePoint is encouraging and supports fast and agile product experiences that work seamlessly on all platforms and devices."
          isExpanded={true}
        />
        <Principle
          icon="images/iconRunner.svg"
          name="Dynamic and alive"
          description="SharePoint experiences are dynamic and adapt to the creator. Allowing for customization to express your brand and meet the needs of your audience."
        />
        <Principle
          icon="images/iconPeople.svg"
          name="Authentic and useful"
          description="SharePoint stays relevant and useful providing tool, systems and capabilities to design and build sites that help people and business achieve more."
        />
        <Principle
          icon="images/iconBulb.svg"
          name="Forward-thinking"
          description="SharePoint experiences search for what's possible beyond todays way of getting things done. We care about the needs of people not only today, but tomorrow — what and how they'll create and how technology can make their content have impact."
        />
        <Principle
          icon="images/iconAccessibility.svg"
          name="Accessible and optimized"
          description="Accessibility is developing an equal experience for all users that enables individuals to adjust their user experience to meet their unique visual, hearing, dexterity, cognitive, and speech needs. SharePoint believes strongly in providing accessible experiences for everyone, everywhere, and in optimizing our experiences to reflect the needs of all of our customers."
        />
      </List>
    </Section>
  );
};



// WEBPACK FOOTER //
// ./src/sections/principles.js